import { TXCategoryFilterTemplate } from "../../../types/common/templates.types";
import { X_CATEGORY_FILTER_TEMPLATE1 } from "./template1";

export const X_CATEGORY_FILTER_TEMPLATES: TXCategoryFilterTemplate = {
  ...X_CATEGORY_FILTER_TEMPLATE1,
};
